import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function TitleUpdater() {
 let location = useLocation();

 useEffect(() => {
  switch(location.pathname) {
    case '/mati':
     document.title = 'Matias Amuchastegui';
     break;
    case '/leandro':
     document.title = 'Leandro Maydana';
     break;
    case '/luana':
      document.title = 'Luana Centeno';
      break;
   default:
     document.title = 'Condamind';
   }
 }, [location]);

 return null;
}

export default TitleUpdater;